import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input, Textarea } from "rbx";
import { BooleanInput, CompanySelect } from "../inputs";

const UserGroupForm = ({ inputs, onChange, adding }) => (
  <React.Fragment>
    <Field kind="group">
      <Control>
        <Label>Group Id</Label>
        <Input
          required
          autocomplete="new"
          name="GroupId"
          readOnly={!adding}
          type="text"
          value={inputs.GroupId}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <Label>Name</Label>
        <Input
          required
          autocomplete="new"
          name="Name"
          type="text"
          value={inputs.Name}
          onChange={onChange}
        />
      </Control>
      <Control expanded>
        <CompanySelect
          icon="globe"
          label="Company"
          name="CompanyId"
          value={inputs.CompanyId}
          onChange={onChange}
        />
      </Control>
      <Control>
        <Label>Active</Label>
        <BooleanInput name="Active" value={inputs.Active} onChange={onChange} />
      </Control>
    </Field>
    <Field>
      <Control>
        <Label>Description</Label>
        <Textarea
          name="Description"
          rows="3"
          value={inputs.Description}
          onChange={onChange}
        />
      </Control>
    </Field>
  </React.Fragment>
);

UserGroupForm.propTypes = {
  inputs: PropTypes.object,
  adding: PropTypes.bool,
  onChange: PropTypes.func
};
UserGroupForm.defaultPropps = {
  adding: false
};
export default UserGroupForm;
